import { Wording } from '@/types';

export const YOGA_WORDING_SE: Wording = {
  components_header_media_content: 'Träningspass',
  components_header_media_1: '',
  components_header_text1: 'Recept',
  components_header_text2: 'Blogg',
  components_header_members: 'Medlemmar',
  hero_text: 'Håll din kropp flexibel och stark',
  hero_button_text: 'Börja din yogaresa',
  components_ressources_section_title: 'RESURSER',
  components_ressources_subheader_text: 'Alla resurser du behöver för en harmonisk livsstil',
  components_ressources_span_text: 'Lås upp hemligheterna bakom välbefinnande: Dyk ner i en samling yogapositioner, medvetna meditationer och hälsosamma recept för att skapa balans i alla aspekter av ditt liv.',
  components_ressources_card_1_title: 'Yogatips',
  components_ressources_card_1_text: 'Praktiska råd för att fördjupa din övning och finslipa dina poser.',
  components_ressources_card_2_title: 'Diet',
  components_ressources_card_2_text: 'Smarta kosttips för ett hälsosammare och starkare jag.',
  components_ressources_link: 'Titta på videor',
  components_notes_and_google_title_1: 'Yogaträningspass',
  components_notes_and_google_title_2: 'Regelbunden rutin',
  components_notes_and_google_title_3: 'Kostunderhåll',
  components_review_google_text: 'Recensera på Google',
  media_content_section_title: 'TRÄNINGSPASS',
  media_content_section_subheader_text: 'Våra videor',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Fler videor',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Artiklar och nyheter',
  text2_section_button_more: 'Fler artiklar',
  components_text1_section_title: 'RECEPT',
  components_text1_subheader_text: 'Nära din kropp och ditt sinne',
  components_text1_span_text: 'Hälsosamma recept som stödjer din yogapraktik och förbättrar ditt välbefinnande.',
  components_text1_card_1_title: 'Energigivande frukostar',
  components_text1_card_1_text: 'Vakna upp till livfulla, energigivande måltider.',
  components_text1_card_3_title: 'Power-packed luncher',
  components_text1_card_3_text: 'Upptäck läckra och smidiga lunchrecept utformade för din aktiva livsstil. Från färgglada sallader till proteinrika wraps håller dessa recept dig mätt och fokuserad.',
  components_text1_card_2_title: 'Middagar för återhämtning',
  components_text1_card_2_text: 'Utforska en mängd olika magert protein, fullkorn och livfulla grönsaker för ett tillfredsställande avslut på dagen.',
  components_text1_link: 'Visa alla recept',
  components_footer_text: 'Hitta balans, andas djupt: Din yoga, din resa.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Rättslig',
  components_footer_terms: 'Villkor',
  components_footer_privacy: 'Integritetspolicy',
  button_load_more: 'Ladda mer',
  page_media_1_content_hero_text: 'Yogaträning',
  page_text1_hero_text: 'Recept',
  page_text1_section_title: 'Näring',
  page_text1_subheader_text: 'Recept',
  page_text2_hero_text: 'Vår blogg',
  page_text2_section_title: 'Blogg',
  page_text2_subheader_text: 'Artiklar och nyheter',
  enter_email_title: 'Ange din e-postadress för att fortsätta',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Skriva in',
  components_login_success_text: 'Inloggningen lyckades!',
  components_card_link_media_content: 'Titta nu',
  components_card_link_text1_content: 'Visa recept',
  components_card_link_text2_content: 'Visa artikel',
  france: 'Frankrike',
  cyprus: 'Cypern',
};